export default function DownloadProgressBar({ progress }) {
  if (!progress) return null;

  const percent = Math.round((progress.loaded / progress.total) * 100);

  return (
    <div className="mt-3">
      <div className="progress" style={{ height: "8px" }}>
        <div
          className="progress-bar"
          style={{ width: `${percent}%` }}
        ></div>
      </div>
      <small className="text-muted">
        {(progress.loaded / 1024).toFixed(1)} KB /{" "}
        {(progress.total / 1024).toFixed(1)} KB
      </small>
    </div>
  );
}